import React from 'react';
import Header from './Header';
import FooterOther from './FooterOther';
import servicos_basicos_saude from '../assets/images/IMG_4130.png';

const occupationalHealthPreventionUnit = () => {
    return (
        <div>
            <Header />
            <img src={servicos_basicos_saude} className="image-ajustada" style={{ width: '100%' }} alt="Unidade de Prevenção & Saúde no Trabalho" />
            <section className="request-proposal" id="solicitar-proposta">
                <div className="container-fluid">
                    <div className="row p-0 text-center">
                        <div className="col-12 title">Unidade de Prevenção & Saúde no Trabalho</div>
                    </div>
                </div>
            </section>
            <section className="request-proposal-form" id="solicitar-proposta">
                <div className="container py-3">
                    <div className="row">
                        <div className="col-12">
                            A unidade móvel de saúde para o trabalhador é uma solução prática e eficiente para atender às demandas de saúde ocupacional diretamente na sua empresa, com estrutura completa e pronta para uso imediato.
                        </div>
                        <div className="col-12 py-3">
                            Essa solução elimina a necessidade de deslocamentos, economizando tempo e promovendo o bem-estar dos colaboradores. Além de facilitar o cumprimento de normas legais, como exames periódicos e  admissionais, ajuda a reduzir afastamentos por meio de ações preventivas. Flexíveis e personalizáveis, as  unidades atendem empresas de diversos portes e segmentos, reforçando a valorização e o engajamento da equipe.
                        </div>
                        <div className="col-12 py-3">
                            <strong>Exames e Serviços Disponíveis: </strong>
                        </div>
                        <div className="col-12 py-3">
                            <ul>
                                <li>Mamografia</li>
                                <li>Raio-X OIT </li>
                                <li>Espirometria</li>
                                <li>Acuidade Visual </li>
                                <li>Avaliação de Risco Cardiovascular</li>
                                <li>Eletrocardiograma</li>
                                <li>Exames Laboratoriais Diversos </li>
                                <li>Exames Toxicológicos</li>
                                <li>Avaliação Psicológica</li>
                                <li>Atendimento Clínico</li>
                                <li>Atendimento de Enfermagem do Trabalho</li>
                            </ul>
                        </div>
                        <div className="col-12 py-3">
                            Seja para exames periódicos, campanhas de saúde ou consultas preventivas, nossa unidade móvel é a escolha ideal para garantir cuidado de qualidade no ambiente de trabalho.
                        </div>
                        <div className="col-3 py-2"> <a href="https://wa.me/556598106742" target="_blank" className="btn btn-warning text-uppercase d-block rounded-0 py-3"><strong>Quero Contratar</strong></a> </div>

                    </div>
                </div>
            </section>
            <FooterOther />
        </div>

    );
};

export default occupationalHealthPreventionUnit;